import React from 'react';

const MvpCta = () => {
    return (
        <div className="section mvp-cta-area" style={{ paddingTop: "20px" }}>
            <div className="container">
                <div className="mvp-cta-box p-5 rounded d-flex flex-column flex-md-row align-items-center justify-content-between">
                    <div className="cta-content text-center text-md-start mb-4 mb-md-0" style={{ maxWidth: "600px" }}>
                        <h2 className="title fw-bold mb-3" style={{ fontSize: "32px" }}>
                            Let's Build Your MVP in Just 6-8 Weeks!
                        </h2>
                        <p className="subtitle mb-0 text-muted" style={{ fontSize: "16px" }}>
                            Tell us about your idea - we'll get back to you within 24 hours with a clear plan and honest estimate.
                        </p>
                    </div>
                    <div className="cta-action">
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                if (window.Calendly) {
                                    window.Calendly.initPopupWidget({ url: "https://calendly.com/itcodeinfotech/itcode_infotech_tech_solutions" });
                                } else {
                                    window.open("https://calendly.com/itcodeinfotech/itcode_infotech_tech_solutions", "_blank", "noopener,noreferrer");
                                }
                            }}
                            className="axil-btn"
                            style={{
                                padding: "15px 32px",
                                borderRadius: "80px",
                                backgroundColor: "#006bff",
                                color: "#fff",
                                border: "1px solid #006bff",
                                fontWeight: "600",
                                fontSize: "16px",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                transition: "all 0.3s ease",
                                boxShadow: "0 4px 12px rgba(0, 107, 255, 0.2)"
                            }}
                        >
                            Schedule a meeting
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MvpCta;
